<template>
<!-- 巡检员列表 -->
  <div>
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="姓名">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.phone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <el-button type="success" @click="addStaffFun('add')">添加</el-button>
        </el-form-item>
      </el-form>
    </div>

    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
      :tableCellClassName="tableCellClassName"
      :tableCellClick="tableCellClick"
    >
      <template #photo="slotData">
        <el-image v-if="slotData.data.row.avatar" style="width: 100px; height: 50px" :src="slotData.data.row.avatar" :preview-src-list="[slotData.data.row.avatar]" :key="slotData.data.row.id">
          <div slot="error" class="image-slot" style="width: 100px; height: 50px">
            <img src="@/assets/imgFail.png" alt="" style="width: 60px; height: 40px">
          </div>
        </el-image>
        <span style="color: gray" v-else>暂无</span>
      </template>
      <template #handlerSlot="slotData">
        <el-button
          type="primary"
          size="mini"
          @click="addStaffFun('edit', slotData.data.row)">编辑</el-button>
        <el-popconfirm title="确定删除吗？" @confirm="staffHandleDelete(slotData.data.row)">
          <template #reference>
            <el-button
              size="mini"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-popconfirm>
      </template>
    </e-table>

    <el-drawer
      :title="title"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <recyclertAddEdit
        @saveSubmit="saveSubmit"
        :recycleData="recycleData"
        :isQuery="isQuery"
        v-if="drawer"
      ></recyclertAddEdit>
    </el-drawer>

  <el-dialog title="管辖小区列表" :visible.sync="communityCountDialog">
    <el-tag style="margin-right: 5px" v-for="(item, index) in communityList" :key="index">{{item.name}}</el-tag>
  </el-dialog>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
import recyclertAddEdit from "./component/recyclertAddEdit.vue";
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  components: { eTable, recyclertAddEdit },
  mixins: [listMixin],
  created () {
    // this.getStaffList()
    // this.loadData(1)
  },
  data() {
    return {
      url: {
        list: '/wlInspectionUser/list',
        addStaff: '/wlInspectionUser/save',
        editStaff: '/wlInspectionUser/detail',
      },
      //字段权限
      loading: false,
      queryParam: {
        name: "",
        phone: "",
      },
      columns: [
        { field: "name", label: "姓名" },
        { field: "phone", label: "手机号", width: 200 },
        { field: "address", label: "地址" },
        { field: "communityCount", label: "管辖数量" },
        {
          width: 200,
          label: "图片",
          slotName: "photo",
          columnType: "slot",
        },
        {
          width: 200,
          label: "操作",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
      communityCountDialog: false,
      communityList: [],
      // 新增信息
      title: '',
      drawer: false,
      isQuery: false,
      recycleData: {},
    };
  },
  methods: {
    tableCellClassName({ column, columnIndex }) {
      if (column.property === "communityCount") {
        return 'blue'
      }
      return '';
    },
    tableCellClick (row, column, cell, event) {
      // console.log('tableCellClick', row, column, cell, event);
      if (column.property === "communityCount") {
        this.communityCountDialog = true
        this.communityList = row.communityList
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    addStaffFun(where, row) {
      this.drawer = true;
      this.isQuery = false;
      if (where == "add") {
        this.title = "新增巡检员";
      } else {
        this.title = "编辑巡检员";
        // if (where == "query") {
        //   this.title = "回收员详情";
        //   this.isQuery = true;
        // }
        httpAction('/wlInspectionUser/detail/' + row.id, {}, 'get').then((res) => {
          if (res.code == 200) {
            this.recycleData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
        // recycleUserdetail(obj).then((res) => {
        //   if (res.code == 200) {
        //     this.recycleData = res.data;
        //   } else {
        //     this.$message.error(res.msg);
        //   }
        // });
      }
    },
    saveSubmit(params) {
      httpAction(this.url.addStaff, params, 'post').then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.$message.success("操作成功");
            this.drawer = false;
            this.currentPage = 1;
            this.loadData(1)
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    staffHandleDelete (val) {
      console.log(val);
      httpAction('/wlInspectionUser/delete/' + val.id, {}, 'get').then(res => {
        console.log(res);
        if (res.code == 200) {
          this.$message.success("操作成功");
          this.loadData(1)
        } else {
          this.$message.error(res.msg);
        }
      })
    }
  },
};
</script>

<style scoped>
	/deep/.el-table .blue {
    color: blue !important;
    text-decoration:underline;
    cursor: pointer;
	}
  
  .search_wrap {
    margin: 10px 0;
  }
</style>